import { createServer } from 'miragejs';
import { storeGet } from './store';

(process.env.REACT_APP_API_MOCK || process.env.STORYBOOK_APP_API_MOCK) &&
  createServer({
    routes() {
      this.namespace = 'api';

      this.get('/store', () => storeGet);
    },
  });
